import download from "downloadjs";
import Swal from "sweetalert2";
const axios = require("axios");
const API_BASE = process.env.REACT_APP_API_BASE;

export const postAPI = async function (url, data) {
  let _token = localStorage.getItem("token");
  if (!_token) {
    _token = data._token;
  }
  const headers = {
    // "Content-Type": "application/json",
    Authorization: "Bearer " + _token,
  };
  let responseMessage;
  try {
    url = API_BASE + url;
    let requestOptions = {
      method: "POST",
      url: url,
      data: data,
      headers: headers,
    };

    const postApiRes = await axios(requestOptions);
    responseMessage = postApiRes.data;
    if (responseMessage.status === 0) {
      if (
        responseMessage.messageCode === "TOKEN_EXPIRED" ||
        responseMessage.messageCode === "UNAUTHORIZED"
      ) {
        localStorage.clear();
        window.location = "/";
      }
    }
    return postApiRes.data;
  } catch (err) {
    if (err.response.data.status === 0) {
      if (
        err.response.data.messageCode === "TOKEN_EXPIRED" ||
        err.response.data.messageCode === "UNAUTHORIZED"
      ) {
        localStorage.clear();
        window.location = "/";
      }
    }
    return err.response.data;
  }
};

const buildAuthHeaders = (isMultipart = false) => {
  const _token = localStorage.getItem("token");
  const headers = {
    Authorization: "Bearer " + _token,
  };
  if (!isMultipart) {
    headers["Content-Type"] = "application/json";
  }
  return headers;
};

const handleAuthError = (responseMessage) => {
  if (
    responseMessage?.status === 0 &&
  (responseMessage?.messageCode === "TOKEN_EXPIRED" ||
    responseMessage?.messageCode === "UNAUTHORIZED")
  ) {
    localStorage.clear();
    window.location = "/";
  }
};

export const postFormData = async function (url, formData) {
  try {
    const postApiRes = await axios({
      method: "POST",
      url: API_BASE + url,
      data: formData,
      headers: buildAuthHeaders(true),
    });
    handleAuthError(postApiRes.data);
    return postApiRes.data;
  } catch (err) {
    if (err?.response?.data) {
      handleAuthError(err.response.data);
      return err.response.data;
    }
    return { status: 0, message: "Request failed", payload: {} };
  }
};

export const putFormData = async function (url, formData) {
  try {
    const putApiRes = await axios({
      method: "PUT",
      url: API_BASE + url,
      data: formData,
      headers: buildAuthHeaders(true),
    });
    handleAuthError(putApiRes.data);
    return putApiRes.data;
  } catch (err) {
    if (err?.response?.data) {
      handleAuthError(err.response.data);
      return err.response.data;
    }
    return { status: 0, message: "Request failed", payload: {} };
  }
};

export const get = async function (url, queryParameter) {
  let _token = localStorage.getItem("token");
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + _token,
  };
  try {
    url = API_BASE + url;
    let requestOptions = {
      method: "GET",
      url: url,
      // data: JSON.stringify(data),
      params: queryParameter,
      headers: headers,
    };
    const getApiRes = await axios(requestOptions);

    if (getApiRes.data.status === 0) {
      if (
        getApiRes.data.messageCode === "TOKEN_EXPIRED" ||
        getApiRes.data.messageCode === "UNAUTHORIZED"
      ) {
        localStorage.clear();
        window.location = "/";
      }
    }
    return getApiRes.data;
  } catch (err) {
    if (err.response.data.status === 0) {
      if (
        err.response.data.messageCode === "TOKEN_EXPIRED" ||
        err.response.data.messageCode === "UNAUTHORIZED"
      ) {
        localStorage.clear();
        window.location = "/";
      }
    }
    return err.response.data;
  }
};

export const putAPI = async function (url, data) {
  let _token = window.localStorage.getItem("token");
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + _token,
  };
  try {
    url = API_BASE + url;
    let requestOptions = {
      method: "PUT",
      url: url,
      data: data,
      headers: headers,
    };
    const putApiRes = await axios(requestOptions);
    if (putApiRes.data.status === 0) {
      if (
        putApiRes.data.messageCode === "TOKEN_EXPIRED" ||
        putApiRes.data.messageCode === "UNAUTHORIZED"
      ) {
        localStorage.clear();
        window.location = "/";
      }
    }
    return putApiRes.data;
  } catch (err) {
    if (err.response.data.status === 0) {
      if (
        err.response.data.messageCode === "TOKEN_EXPIRED" ||
        err.response.data.messageCode === "UNAUTHORIZED"
      ) {
        localStorage.clear();
        window.location = "/";
      }
    }
    return err.response.data;
  }
};

export const deleteAPI = async function (url, data) {
  let _token = window.localStorage.getItem("token");
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + _token,
  };
  try {
    url = API_BASE + url;
    let requestOptions = {
      method: "DELETE",
      url: url,
      data: JSON.stringify(data),
      // params : queryParameter,
      headers: headers,
    };
    const deleteApiRes = await axios(requestOptions);
    if (deleteApiRes.data.status === 0) {
      if (
        deleteApiRes.data.messageCode === "TOKEN_EXPIRED" ||
        deleteApiRes.data.messageCode === "UNAUTHORIZED"
      ) {
        localStorage.clear();
        window.location = "/";
      }
    }
    return deleteApiRes.data;
  } catch (err) {
    if (err.response.data.status === 0) {
      if (
        err.response.data.messageCode === "TOKEN_EXPIRED" ||
        err.response.data.messageCode === "UNAUTHORIZED"
      ) {
        localStorage.clear();
        window.location = "/";
      }
    }
    return err.response.data;
  }
};

export const uploadImageAPI = async function (url, fileData) {
  let _token = localStorage.getItem("token");
  var formData = new FormData();
  // console.log('formdata', fileData)
  for (let i = 0; i < fileData.length; i++) {
    formData.append("files", fileData[i]);
  }
  // formData.append("files", fileData[0]);
  // console.log('form data in api ervice', formData);
  const headers = {
    "Content-Type": "multipart/form-data",
    Authorization: "Bearer  " + _token,
  };
  try {
    const postApiRes = await axios({
      method: "POST",
      url: API_BASE + url,
      data: formData,
      headers: headers,
    });
    // checkToken(postApiRes.data)
    return postApiRes.data;
  } catch (err) {
    if (err.response.data.status === 0) {
      if (
        err.response.data.messageCode === "TOKEN_EXPIRED" ||
        err.response.data.messageCode === "UNAUTHORIZED"
      ) {
        localStorage.clear();
        window.location = "/";
      }
    }
    return err.response.data;
  }
};

export const getDownloadFile = async function (url, fileName = null) {
  let _token = localStorage.getItem("token");
  try {
    const resp = await fetch(API_BASE + url, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + _token,
      },
    });

    if (!resp.ok) {
      throw new Error(`Download failed (${resp.status})`);
    }

    const contentType = resp.headers.get("content-type") || "";
    if (contentType.includes("application/json")) {
      const errorData = await resp.json();
      throw new Error(errorData?.message || "Download failed");
    }

    const blob = await resp.blob();
    if (!blob?.size) {
      throw new Error("No file data received");
    }

    let flName = fileName || Math.floor(new Date().getTime() / 1000);
    download(blob, flName, blob.type || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
    return true;
  } catch (err) {
    Swal.fire({ icon: "error", text: err?.message || "Failed to download file. Please try again.", timer: 2000 });
    return false;
  }
};

export const downloadFile = async function (url, filename) {
  let _token = window.localStorage.getItem("token");
  try {
    return fetch(API_BASE + url, {
      method: "GET",
      headers: {
        "Content-Type": "application/csv",
        Authorization: "Bearer " + _token,
      },
    }).then(function (resp) {
      if(resp.status === 200){
        return resp.blob();
      } else {
        return false;
      }
    }).then(function (blob) {
      if(blob?.size > 0 && blob?.type !== 'application/json'){
        return download(blob, filename);
      } else {
        return Swal.fire({
          text: "No data found to download",
          timer: 1500,
        }).then(() => {
          return false
        });
      }
    });
  } catch (err) {
    // console.error(err);
    return { data: { error: "Internal Server Error" } };
  }
};

const getFileNameFromUrl = (fileUrl) => {
  try {
    const pathname = new URL(fileUrl).pathname;
    const name = decodeURIComponent(pathname.split("/").pop() || "");
    return name || "report.xlsx";
  } catch (err) {
    const urlParts = fileUrl.split("/");
    return decodeURIComponent(urlParts[urlParts.length - 1].split("?")[0] || "report.xlsx");
  }
};

// Download file from external URL (e.g., S3) via API proxy to force a single file save
export const forceDownloadFile = async function (fileUrl, fileName = null) {
  try {
    let downloadFileName = fileName || getFileNameFromUrl(fileUrl);
    if (!downloadFileName.includes(".")) {
      downloadFileName += ".xlsx";
    }

    const proxyUrl = `/reports/proxy-file-download?url=${encodeURIComponent(fileUrl)}&fileName=${encodeURIComponent(downloadFileName)}`;
    return await getDownloadFile(proxyUrl, downloadFileName);
  } catch (err) {
    console.error("Error downloading file:", err);
    Swal.fire({ icon: "error", text: "Failed to download file. Please try again.", timer: 2000 });
    return false;
  }
};
